export default __webpack_public_path__ + "lightworks.4ca0ee0b.png";